import axios from "axios";
import { Asset } from '../customTypings/branding/asset';
import { apiPath, authConfig } from "./api-utils";

export const CURRENT_API_VERSION = 3;

export const getAllBrands = async (apiKey: string) => {
  const url = `${apiPath('branding')}`;
  return await axios.get(url, authConfig(apiKey));
};

export const getBrandAssets = async (apiKey: string, brandId: string) => {
  const url = `${apiPath('branding')}?brand_id=${brandId}`;
  return await axios.get(url, authConfig(apiKey));
};

export const patchBrandAssets = async (apiKey: string, brandId: string, asset: Asset) => {
  const payload = {"brandId": brandId, "asset": asset};
  const url = `${apiPath('branding')}`;
  return await axios.patch(url, payload, authConfig(apiKey)).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
}

export const createBrand = async (apiKey: string, brandName: string) => {
  const url = `${apiPath('branding')}`;
  const payload = {"brandName": brandName};
  return await axios.post(url, payload, authConfig(apiKey)).then((response) => {
    return response;
  }).catch((err) => {
    return err;
  });
}